import axios from "axios"

const AdminService = {}

AdminService.ajouter =(data,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/admin/register`,data,{
    headers:{
    'Authorization': `Bearer ${authorization}` 
    }
})

}

AdminService.Login =(data)=>{
    return axios.post(`${process.env.REACT_APP_API_URL}/admin/login`,data)
    
    }



export default AdminService ;